import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/jaffna.webp',
  './images/J1.webp',
  './images/J2.webp',
  './images/J3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Jaffna, located in the northern tip of Sri Lanka, is a cultural and historical treasure trove with a unique Tamil heritage.

Key highlights include:

• Jaffna Fort – A massive 17th-century Dutch fort offering stunning views of the city and sea, rich with history and architecture.
• Nagadeepa Purana Vihara – A sacred Buddhist temple located on Nagadeepa Island, known for its tranquil surroundings and religious significance.
• Nallur Kandaswamy Kovil – A magnificent Hindu temple famous for its vibrant festivals and intricate Dravidian architecture.
• Casuarina Beach – A pristine, calm beach ideal for relaxation, swimming, and enjoying coastal beauty.
• Delft Island – Known for wild horses, baobab trees, and unique landscapes, accessible by boat from Jaffna.
• Local Markets – Bustling bazaars offering fresh seafood, traditional spices, handwoven textiles, and local crafts.
• Authentic Jaffna Cuisine – Famous for spicy crab curry, Oothappam (savory pancakes), Jaffna crab soup, and various Palmyra-based sweets and snacks.
• Cultural Heritage – Experience traditional music, dance, and festivals reflecting the rich Tamil culture.

Jaffna is a perfect destination for those seeking history, culture, nature, and authentic Sri Lankan Tamil flavors.`,

    zh: `贾夫纳位于斯里兰卡最北端，是拥有独特泰米尔文化遗产的历史文化宝库。

主要亮点包括：

• 贾夫纳堡 – 17世纪荷兰堡垒，俯瞰城市和海景，历史悠久，建筑壮丽。
• 纳加迪帕古纳寺 – 位于纳加迪帕岛的佛教圣地，以宁静环境和宗教意义闻名。
• 纳鲁尔坎达斯瓦米庙 – 著名的印度教寺庙，以其盛大的节日和精美的德拉维达人建筑风格著称。
• 卡苏阿里纳海滩 – 原始宁静的海滩，适合放松、游泳和欣赏海岸美景。
• 德尔夫特岛 – 以野马、猴面包树和独特风光闻名，可从贾夫纳乘船前往。
• 本地市场 – 热闹的集市，提供新鲜海鲜、传统香料、手工织品和本地工艺品。
• 传统贾夫纳美食 – 以香辣螃蟹咖喱、乌塔帕姆（咸味煎饼）、贾夫纳蟹汤及各种棕榈制甜点和小吃闻名。
• 文化遗产 – 感受传统音乐、舞蹈及节庆，展现丰富的泰米尔文化。

贾夫纳是寻求历史、文化、自然和地道斯里兰卡泰米尔风味的理想目的地。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/jaffna.webp" className="travel-image2" />
          <img src="./images/J1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Jaffna</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Jaffna</h2>
          <p className="carousel-subheading">A blend of rich history, Tamil culture, and coastal serenity</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc}  className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
